import MeterReadingForm from './MeterReadingForm.js';

const AddMeterReading = () => {
    return <MeterReadingForm isUpdate={false} />;
    
};

export default AddMeterReading;
